<div class="report pt-4">
  <div class="report-summery">
    <p id="{{title?.split(' ').join('')}}" class="report-summery-heading position-relative mb-0 font-bold">{{title}} <span
        class="completion-percent position-absolute">{{progressPercentage}}%</span></p>
    <div class="progress">
      <div class="progress-bar" [ngClass]="progressColor==='y' ? 'warning' : (progressColor==='r' ? 'danger' : 'success')"
        role="progressbar" [ngStyle]="{'width':progressPercentage+'%'}" [attr.aria-valuenow]="progressPercentage"
        aria-valuemin="0" aria-valuemax="100" attr.aria-labelledby="{{title?.split(' ').join('')}}"></div>
    </div>
    <p class="mb-0 completion-no" *ngIf="viewLocation !== 'public_review'">{{progressDone}} of {{progressTotal}}</p>
  
    <p class="mb-0 completion-no" *ngIf="viewLocation === 'public_review'">{{progressDone}} of
      {{progressTotal}} nodes reviewed</p>
  </div>
</div>